// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logout-card {
    padding-top:110px;
    padding: 20px;
    max-width: 400px;
    height:300px;
    margin: 20px auto;
    margin-top:130px;
    text-align: center;
    background-color: #f8f8f8;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.btn-grp{
    display: flex;
    flex-direction: row;
}

.btn-grp button{
    margin-right: 20px;
}

.logout-card h1 {
    margin-bottom: 16px;
    font-size: 1.5rem;
    color: #333;
}

.logout-card button {
    padding: 10px 20px;
    font-size: 1rem;
    background-color: #d9534f;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    z-index: 0;
}


  



 .logout-card button::after {
      /* this is what all  will be done when mouse outs from the button */
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: #ffa406;
      z-index: -1;
      border-radius:4px;
      transition: 0.3s ease all;
      transform: scale(0, 1);

      /* this is you are to change for diffirent transition; */

      transform-origin: bottom left;
      transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
      transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
  }



.logout-card button:hover::after {
      transform: scale(1, 1);
      transform-origin: top left;
  }



@media screen and (max-width:768px){
    .logout-card{
        
        width:90%;
        height:90%;
        margin: 5%;
        margin-top: 180px;
        padding:0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Logout.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;;;;;;CAOC;MACK,mEAAmE;MACnE,WAAW;MACX,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,YAAY;MACZ,WAAW;MACX,yBAAyB;MACzB,WAAW;MACX,iBAAiB;MACjB,yBAAyB;MACzB,sBAAsB;;MAEtB,wDAAwD;;MAExD,6BAA6B;MAC7B,0DAA0D;MAC1D,0DAA0D;EAC9D;;;;AAIF;MACM,sBAAsB;MACtB,0BAA0B;EAC9B;;;;AAIF;IACI;;QAEI,SAAS;QACT,UAAU;QACV,UAAU;QACV,iBAAiB;QACjB,SAAS;IACb;AACJ","sourcesContent":[".logout-card {\n    padding-top:110px;\n    padding: 20px;\n    max-width: 400px;\n    height:300px;\n    margin: 20px auto;\n    margin-top:130px;\n    text-align: center;\n    background-color: #f8f8f8;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-grp{\n    display: flex;\n    flex-direction: row;\n}\n\n.btn-grp button{\n    margin-right: 20px;\n}\n\n.logout-card h1 {\n    margin-bottom: 16px;\n    font-size: 1.5rem;\n    color: #333;\n}\n\n.logout-card button {\n    padding: 10px 20px;\n    font-size: 1rem;\n    background-color: #d9534f;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    z-index: 0;\n}\n\n\n  \n\n\n\n .logout-card button::after {\n      /* this is what all  will be done when mouse outs from the button */\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      width: 100%;\n      background-color: #ffa406;\n      z-index: -1;\n      border-radius:4px;\n      transition: 0.3s ease all;\n      transform: scale(0, 1);\n\n      /* this is you are to change for diffirent transition; */\n\n      transform-origin: bottom left;\n      transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n      transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n  }\n\n\n\n.logout-card button:hover::after {\n      transform: scale(1, 1);\n      transform-origin: top left;\n  }\n\n\n\n@media screen and (max-width:768px){\n    .logout-card{\n        \n        width:90%;\n        height:90%;\n        margin: 5%;\n        margin-top: 180px;\n        padding:0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
